// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 5px 35px;
}
.wrapper .expenditure-table .k-grid .k-detail-cell {
  padding-left: 0 !important;
  border-left: solid 12px #F4901D !important;
}
.wrapper .expenditure-table .k-grid .k-detail-cell table {
  width: 100%;
}
.wrapper .expenditure-table .k-grid .k-detail-cell table td {
  padding: 8px !important;
  width: auto;
}
.wrapper .expenditure-table .k-grid .k-detail-cell table td.icon-td {
  width: 40px;
}
.wrapper .expenditure-table .k-grid .k-detail-cell table td.p-l-20 {
  padding-left: 40px !important;
}

.no-border {
  border: none;
  padding: 0;
}

.bold {
  font-weight: 700;
}

.py-15 {
  padding-top: 15px;
  padding-bottom: 15px;
}

.warning-wrapper {
  padding-top: 20px;
}

.d-col {
  display: flex;
  flex-direction: column;
}

.d-row {
  display: flex;
  flex-direction: row;
}

.justify-content-between {
  justify-content: space-between;
}

.start-center {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/in-kind-contributions/in-kind-contributions.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAEY;EACQ,0BAAA;EACA,0CAAA;AAApB;AAEgB;EACI,WAAA;AAApB;AAEoB;EACI,uBAAA;EACA,WAAA;AAAxB;AAGoB;EACI,WAAA;AADxB;AAIoB;EACI,6BAAA;AAFxB;;AAUA;EACI,YAAA;EACA,UAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,iBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,sBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,mBAAA;AAPJ;;AAUA;EAA2B,8BAAA;AAN3B;;AASA;EACI,aAAA;EACA,mBAAA;AANJ","sourcesContent":[".wrapper {\n    padding: 5px 35px;\n    .expenditure-table {\n        .k-grid {\n            .k-detail-cell {\n                    padding-left: 0 !important;\n                    border-left: solid 12px #F4901D !important;\n             \n                table {\n                    width: 100%;\n\n                    td {\n                        padding: 8px !important;\n                        width: auto;\n                    }\n\n                    td.icon-td {\n                        width: 40px;\n                    }\n\n                    td.p-l-20 {\n                        padding-left: 40px !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.no-border {\n    border: none;\n    padding: 0;\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.py-15 {\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.warning-wrapper {\n    padding-top: 20px\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.justify-content-between { justify-content: space-between; }\n\n\n.start-center {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
